import type { ReactNode } from 'react';

/**
 * One badge/pill style for the whole app (order status, A/R hold, yes/no flags).
 * Centralizes the pastel status palette that used to be copy-pasted as inline
 * hex in several screens.
 */
export type BadgeVariant = 'open' | 'invoiced' | 'cancelled' | 'quote' | 'danger' | 'good' | 'neutral';

const VARIANTS: Record<BadgeVariant, [bg: string, fg: string]> = {
  open: ['#e0f4e9', '#168552'],
  good: ['#e0f4e9', '#168552'],
  invoiced: ['#e0eafc', '#1e5ba8'],
  cancelled: ['#fce4e1', '#d6483b'],
  danger: ['#fce4e1', '#d6483b'],
  quote: ['#fff1d9', '#a8770a'],
  neutral: ['#eef2f7', '#5c6b80'],
};

export function Badge({ children, variant = 'neutral' }: { children: ReactNode; variant?: BadgeVariant }) {
  const [bg, fg] = VARIANTS[variant] ?? VARIANTS.neutral;
  return (
    <span className="kd-badge" style={{ background: bg, color: fg }}>
      {children}
    </span>
  );
}

/** Map a sales order's status/type to a badge variant + label. */
export function orderBadge(status: string, type: string): { variant: BadgeVariant; label: string } {
  if (type === 'quote') return { variant: 'quote', label: 'quote' };
  const known: BadgeVariant[] = ['open', 'invoiced', 'cancelled'];
  return { variant: (known as string[]).includes(status) ? (status as BadgeVariant) : 'neutral', label: status };
}
